import { MapPin, Navigation } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { business } from "../data/business";

export default function Location() {
    return (
        <section
            id="localizacao"
            data-testid="location-section"
            className="bg-paper py-20 sm:py-28 lg:py-36"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-8 lg:grid-cols-12 lg:px-16">
                <div className="lg:col-span-5">
                    <Eyebrow>Localização</Eyebrow>
                    <Reveal delay={0.1}>
                        <h2 className="mt-5 font-display text-3xl font-medium uppercase leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                            Estamos <span className="italic text-accent">perto de você.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="mt-6 flex items-start gap-3 text-sm text-ink-soft sm:text-base">
                            <MapPin size={18} className="mt-0.5 shrink-0 text-accent" />
                            <span>
                                Studio Danielly Sousa
                                <br />
                                {business.city} – {business.state}
                            </span>
                        </p>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <a
                            href={business.directions}
                            data-testid="location-cta"
                            className="mt-8 inline-flex items-center gap-3 bg-ink px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-accent"
                        >
                            Como chegar
                            <Navigation size={14} />
                        </a>
                    </Reveal>
                    <Reveal delay={0.35}>
                        <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-ink-soft/70">
                            ◇ Toque no mapa ou em "Como chegar" para abrir a rota no
                            Google Maps.
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={0.15} className="lg:col-span-7">
                    <div
                        data-testid="location-map"
                        className="relative aspect-[16/10] overflow-hidden border border-line bg-cream"
                    >
                        <iframe
                            title="Mapa — Studio Danielly Sousa em Uruaçu – GO"
                            src={business.mapsEmbed}
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            className="h-full w-full border-0"
                        />
                        <div className="pointer-events-none absolute bottom-4 left-4 border border-line bg-paper/95 px-4 py-2.5 backdrop-blur-sm">
                            <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-ink">
                                Studio Danielly Sousa
                            </p>
                            <p className="mt-0.5 text-xs text-ink-soft">
                                Uruaçu – GO • Encontre "Danielly Nails" no Google Maps
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
